import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './variables.css';
import './design.css';
import Header from './Header';
import Footer from './Footer';
import HomePage from './HomePage';
import CompanyPage from './CompanyPage';
import ContactForm from './ContactForm';
import Service from './Service';
import ContentListPage from './ContentListPage';
import ContentDetailPage from './ContentDetailPage';
import CaseStudyPage from './CaseStudyPage';
import CaseStudyDetail from './CaseStudyDetail';
import RecruitPage from './RecruitPage';
import MediaPage from './MediaPage';
import OsumitsukiScorePage from './OsumitsukiScorePage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import NotFoundPage from './NotFoundPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/service" element={<Service />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/content" element={<ContentListPage />} />
          <Route path="/content/:id" element={<ContentDetailPage />} />
          <Route path="/case-studies" element={<CaseStudyPage />} />
          <Route path="/case-study/:id" element={<CaseStudyDetail />} />
                <Route path="/recruit" element={<RecruitPage />} />
                <Route path="/media" element={<MediaPage />} />
                <Route path="/osumitsuki-score" element={<OsumitsukiScorePage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
